module.exports = __webpack_public_path__ + "static/img/about_15.da1b687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_15.png
// module id = PZF5
// module chunks = 1